export default {
    policyCheck: {
        required: true
    },
}